import { ReportEntity } from 'store/src/lib/services/types';
import isSdaFormatReport from './isSdaFormatReport';

// raytd/web#218: SDA reports never include a Summary section, regardless of what's stored in
// section_config (a report saved before this shipped, or an SDA report re-formatted from
// another type, could still carry `includeSummary: true`) — every consumer of Summary visibility
// (nav tabs, the print route, the section-config settings form) reads through this single
// function so the SDA override can't be missed at one call site while another still shows it.
export default function isSummaryIncludedForReport(report: ReportEntity | null | undefined): boolean {
    if (isSdaFormatReport(report)) return false;
    return report?.section_config?.includeSummary ?? true;
}
